// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CrAG","newExpiryDate":"styles_newExpiryDate__1FBzU","footer":"styles_footer__-jP-H"};